import styled from 'styled-components'

import Input from 'components/Input'

export default styled(Input).attrs({ as: 'textarea' })``
